 
import Button from "@material-ui/core/Button";
 
const index = ({additionClass,loading,text,handleClick, disabled}) => {
    return (
      <>
       {handleClick === undefined ? (
        <Button
            className={"submitBtn smallBtn "+additionClass}

             variant="contained"
             type="submit"
             disabled={loading}
          >
         { text }
        </Button>
       ):(
        <Button
            className={"submitBtn smallBtn "+additionClass}
            variant="contained"
            type="button"
            
            onClick={e=>handleClick()}
            disabled={loading || disabled}
            >
          { text }
        </Button>
   
       )}
       </>
    );
  }
  
  export default index;
  